import { BandLogo } from "./Shared";

export const Marquee = () => {
  const items = Array.from({ length: 6 });
  return (
    <div data-testid="marquee" className="border-y border-[var(--line)] py-6 md:py-8 overflow-hidden bg-[#060606] select-none">
      <div className="marquee-track flex w-max whitespace-nowrap">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
            {items.map((_, i) => (
              <div key={i} className="flex items-center">
                <span className="font-serif-display italic text-3xl md:text-5xl px-6 md:px-10 text-[var(--off)]">
                  Adv. Sanjay Kr Sinha
                </span>
                <BandLogo className="h-7 w-6 text-[var(--muted)]" />
                <span className="font-mono-plex text-xs uppercase tracking-[0.3em] px-6 md:px-10 text-[var(--muted)]">
                  Civil &amp; Revenue — Purnia, Bihar
                </span>
                <BandLogo className="h-7 w-6 text-[var(--muted)]" />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
